import Raven from 'raven-js';
import { FEATURES } from '../../constants/features';
import { DEFAULT_APP_NAME } from '../../constants/general';
import { getFeatureDisabledReason } from '../../utils/features';
export const SET_SKIP_REFRESH = 'SET_SKIP_REFRESH';
export const SET_IS_PAGE_HIDDEN = 'SET_IS_PAGE_HIDDEN';
export const RESET_APP_STATE = 'RESET_APP_STATE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const POSTPONE_ACTION = 'POSTPONE_ACTION';
export const SET_IS_IN_MEETING = 'SET_IS_IN_MEETING';
export const SET_IS_PAST_MEETING = 'SET_IS_PAST_MEETING';
export const SET_STORE_BEFORE_INIT = 'SET_STORE_BEFORE_INIT';
export const SET_SCOPES = 'SET_SCOPES';
export const initialState = {
  isLoading: false,
  skipRefresh: false,
  isPageHidden: false,
  isInMeeting: null,
  isPastMeeting: false,
  appName: DEFAULT_APP_NAME,
  features: {
    MAPPING_PARTICIPANTS_TO_CONTACTS: {
      available: true,
      reason: undefined
    },
    MAKING_CALL_NOTES: {
      available: true,
      reason: undefined
    },
    ASSOCIATIONS_CONTACTS_WITH_CALL: {
      available: true,
      reason: undefined
    },
    ASSOCIATIONS_COMPANIES_WITH_CALL: {
      available: true,
      reason: undefined
    },
    ASSOCIATIONS_DEALS_WITH_CALL: {
      available: true,
      reason: undefined
    },
    ASSOCIATIONS_TICKETS_WITH_CALL: {
      available: true,
      reason: undefined
    },
    ASSOCIATIONS_MEETINGS_WITH_CALL: {
      available: true,
      reason: undefined
    },
    CREATING_DEALS_WITH_LINE_ITEMS: {
      available: true,
      reason: undefined
    },
    PLAYBOOKS: {
      available: true,
      reason: undefined
    }
  }
};
export const reducer = (state, action) => {
  switch (action.type) {
    case SET_SCOPES:
      {
        const {
          scopeGroups,
          scopes
        } = action.payload;
        return Object.assign({}, state, {
          features: Object.keys(FEATURES).reduce((acc, key) => {
            const feature = FEATURES[key];
            const hasScopes = feature.scopes.every(scope => scopes.includes(scope));
            const hasScopeGroups = feature.scopeGroups.every(scope => scopeGroups.includes(scope));
            acc[key] = {
              available: hasScopes && hasScopeGroups,
              reason: getFeatureDisabledReason({
                hasScopes,
                hasScopeGroups
              })
            };
            return acc;
          }, {})
        });
      }
    case SET_STORE_BEFORE_INIT:
      return Object.assign({}, state, action.payload);
    case SET_IS_PAST_MEETING:
      {
        Raven.captureBreadcrumb({
          message: 'app.slice.setIsPastMeeting',
          level: 'debug',
          data: action.payload
        });
        return Object.assign({}, state, {
          isPastMeeting: action.payload
        });
      }
    case SET_IS_IN_MEETING:
      return Object.assign({}, state, {
        isInMeeting: action.payload
      });
    case SET_IS_LOADING:
      return Object.assign({}, state, {
        isLoading: action.payload
      });
    case SET_IS_PAGE_HIDDEN:
      {
        Raven.captureBreadcrumb({
          message: 'app.slice.setIsPageHidden',
          level: 'debug',
          data: action.payload
        });
        return Object.assign({}, state, {
          isPageHidden: action.payload
        });
      }
    case SET_SKIP_REFRESH:
      return Object.assign({}, state, {
        skipRefresh: action.payload
      });
    case RESET_APP_STATE:
      return Object.assign({}, initialState, {
        appName: state.appName
      });
    default:
      return state;
  }
};